import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [clinic, setClinic] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem("lf_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setClinic(data.clinic);
    } catch {
      localStorage.removeItem("lf_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("lf_token", data.token);
    setUser(data.user);
    setClinic(data.clinic);
    return data;
  };

  const signup = async (email, password, full_name, clinic_name) => {
    const { data } = await api.post("/auth/signup", { email, password, full_name, clinic_name });
    localStorage.setItem("lf_token", data.token);
    setUser(data.user);
    setClinic(data.clinic);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("lf_token");
    setUser(null);
    setClinic(null);
    window.location.href = "/app/login";
  };

  return (
    <AuthContext.Provider value={{ user, clinic, loading, login, signup, logout, loadUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
